(() => {
  'use strict';
  const pattern = /(?:\+64[\s\u00a0().-]*(?:\(0\)[\s\u00a0.-]*)?|0)[2-9](?:[\s\u00a0().-]*\d){7,9}\b/g;
  const excluded = 'a,button,script,style,noscript,textarea,input,select,option,code,pre,svg,[contenteditable="true"]';
  function destination(text) {
    let digits = text.replace(/\(0\)/g, '').replace(/\D/g, '');
    digits = digits.startsWith('64') ? digits.slice(2) : digits.slice(1);
    return /^(?:2\d{7,9}|[34679]\d{7}|(?:800|508)\d{6,7})$/.test(digits) ? 'tel:+64' + digits : null;
  }
  function linkText(node) {
    if (!node.parentElement || node.parentElement.closest(excluded)) return;
    const text = node.nodeValue;
    pattern.lastIndex = 0;
    const matches = [...text.matchAll(pattern)].filter(match => destination(match[0]));
    if (!matches.length) return;
    const fragment = document.createDocumentFragment();
    let cursor = 0;
    for (const match of matches) {
      if (match.index > 0 && /[\w+]/.test(text[match.index - 1])) continue;
      fragment.append(document.createTextNode(text.slice(cursor, match.index)));
      const link = document.createElement('a');
      link.href = destination(match[0]);
      link.className = 'magpie-phone-link';
      link.textContent = match[0];
      fragment.append(link);
      cursor = match.index + match[0].length;
    }
    if (!cursor) return;
    fragment.append(document.createTextNode(text.slice(cursor)));
    node.replaceWith(fragment);
  }
  function scan(root) {
    if (root.nodeType === Node.TEXT_NODE) return linkText(root);
    if (root.nodeType !== Node.ELEMENT_NODE || root.closest(excluded)) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(linkText);
  }
  function start() {
    scan(document.body);
    new MutationObserver(records => {
      for (const record of records) {
        if (record.type === 'characterData') scan(record.target);
        else record.addedNodes.forEach(scan);
      }
    }).observe(document.body, {subtree: true, childList: true, characterData: true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
})();
